﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import theme from "./Table.module.sass";

const TABLE = ({
  classes = [],
  ...props
}) => (
  <table {...props} className={classNames(theme.TABLE, ...classes)} />
);

const THEAD = ({
  classes = [],
  ...props
}) => (
  <thead {...props} className={classNames(theme.THEAD, ...classes)} />
);

const TBODY = ({
  classes = [],
  ...props
}) => (
  <tbody {...props} className={classNames(theme.TBODY, ...classes)} />
);

const TFOOT = ({
  classes = [],
  ...props
}) => (
  <tfoot {...props} className={classNames(theme.TFOOT, ...classes)} />
);

const TH = ({ children = null, ...rest }) => (
  <th {...rest} className={theme.TH}>
    {children}
  </th>
);

const TR = ({ classes = [], ...props }) => <tr {...props} className={classNames(theme.TR, ...classes)} />;

const TD = ({ classes = [], ...props }) => <td {...props} className={classNames(theme.TD, ...classes)} />;

const COL = ({ classes = [], ...props }) => <col {...props} className={classNames(theme.COL, ...classes)} />;

const COLGROUP = ({ classes = [], ...props }) => <colgroup {...props} className={classNames(theme.COLGROUP, ...classes)} />;

const CAPTION = ({ classes = [], ...props }) => <caption {...props} className={classNames(theme.CAPTION, ...classes)} />;

const proptypes = {
  classes: PropTypes.array,
};

TABLE.propTypes = proptypes;
THEAD.propTypes = proptypes;
TBODY.propTypes = proptypes;
TFOOT.propTypes = proptypes;

TH.propTypes = {
  ...proptypes,
  children: PropTypes.node,
};

TR.propTypes = proptypes;
TD.propTypes = proptypes;
COL.propTypes = proptypes;
COLGROUP.propTypes = proptypes;
CAPTION.propTypes = proptypes;

export {
  TABLE,
  THEAD,
  TBODY,
  TFOOT,
  TH,
  TR,
  TD,
  COL,
  COLGROUP,
  CAPTION
};
